import type { ReadSearchApiArg } from 'lib-search-types';
import { filterFieldCatalogue, filterOperatorCatalogue } from 'lib-search-ui';
import { memo, useMemo } from 'react';

import { SearchScopeFilter } from 'components/search';

import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

export const SearchTagsQuickFilter = memo(
  function SearchTagsQuickFilter(): JSX.Element {
    const { condition, handleChange } = useSearchQuickFilter('tags');

    const initialArg = useMemo(
      (): ReadSearchApiArg<'tags'> => ({
        scope: 'tags',
        sortBy: { field: 'name', order: 'asc' },
      }),
      [],
    );

    return (
      <SearchScopeFilter
        scope="tags"
        placeholder="Search tags..."
        operators={filterOperatorCatalogue.conversations.tags.operators}
        defaultOperator={
          filterOperatorCatalogue.conversations.tags.defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        initialArg={initialArg}
        onChange={handleChange}
      >
        {filterFieldCatalogue.conversations.tags.label}
      </SearchScopeFilter>
    );
  },
);
